/**
 * Tiny skeleton primitives used in place of "Loading..." text.
 *
 * The customer app already ships a subtle pulse animation on Tailwind's
 * `animate-pulse` utility, and our colours come from the existing
 * shadcn/ui CSS variables (`--secondary`, `--muted`) so these match
 * both light and dark themes.
 */
export function Skeleton({ className = '' }: { className?: string }) {
  return <div className={`animate-pulse rounded-lg bg-secondary ${className}`} />;
}

/** Card with a large image area followed by a title + subtitle. */
export function CardSkeleton() {
  return (
    <div className="bg-card border border-border rounded-2xl overflow-hidden">
      <Skeleton className="h-32 w-full rounded-none" />
      <div className="p-4 space-y-2">
        <Skeleton className="h-4 w-2/3" />
        <Skeleton className="h-3 w-1/2" />
      </div>
    </div>
  );
}

/** Row used in coaches list: avatar + two lines. */
export function RowSkeleton() {
  return (
    <div className="bg-card border border-border rounded-2xl p-4 flex gap-3">
      <Skeleton className="w-16 h-16 rounded-2xl" />
      <div className="flex-1 space-y-2 pt-1">
        <Skeleton className="h-4 w-2/5" />
        <Skeleton className="h-3 w-4/5" />
        <Skeleton className="h-3 w-1/3" />
      </div>
    </div>
  );
}
